import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import pinia from './plugins/pinia'
import router from './router'
import i18n from './plugins/i18n'
import axios from 'axios'
import { ValidationProvider } from 'vee-validate'
import './sass/main.scss'
import moment from 'moment'
import tagManager from './helpers/tagManager'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import { isNil } from 'ramda'
import SawdaysUI from '@sawdays/shared-ui'

Vue.use(SawdaysUI)

// configure sentry
if (!isNil(process.env.VUE_APP_SENTRY_DSN)) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.VUE_APP_HOST_ENV,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  })
}

// Register the validation provider globally
Vue.component('ValidationProvider', ValidationProvider)

Vue.config.productionTip = false

// set axios as the default http client
Vue.prototype.$http = axios

// set up moment js for global usage
Vue.prototype.moment = moment

// set up analytics for global usage
Vue.prototype.tagManager = tagManager

// add any filters
Vue.filter('capitalise', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

new Vue({
  pinia,
  router,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
